import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { setCookie, getCookie, useInterval } from "../components/Common";
import { Palette, API_BASE } from "../AppConfig";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import BSL_Dialog from "../components/BSL_Dialog";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import * as APP from "../redux_store/appState";

const useStyles = makeStyles({
    root: {
        // minHeight: '80px',
        display: "flex",
        flexDirection: "column",
        // marginTop: "-15px"
        paddingTop: "105px",
    },
    announcement: {
        background: "#eaeaea",
        display: "flex",
        minHeight: "60px",
        flexDirection: "row",
        padding: "20px 20px 20px 140px",
        borderBottom: "1px solid #192E61",
    },
    announcement_designer: {
        background: "#eaeaea",
        display: "flex",
        minHeight: "30px",
        flexDirection: "row",
        padding: "3px 0px 0px 100px",
        borderBottom: "1px solid #192E61",
        alignItems: "center",
    },
    warning: {
        background: "#fdf4e7",
        borderBottom: "1px solid #192E61",
    },
    image: {
        height: "80px",
        maxHeight: "80px",
        padding: "0px 20px 0px 0px",
    },
    image_designer: {
        height: "30px",
        maxHeight: "30px",
        padding: "0px 20px 0px 0px",
    },
    content_container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        // maxWidth: '800px',
    },
    header: {
        color: "#555555",
        padding: "3px",
    },
    content: {
        color: "#333333",
        padding: "3px",
        fontSize: "0.85rem",
    },
    link: {
        padding: "3px",
    },
    closeButton: {
        height: "32px",
        width: "32px",
        position: "absolute",
        right: "20px",
    },
    closeButton_designer: {
        height: "32px",
        width: "32px",
        position: "relative",
        marginLeft: "-12px",
        marginRight: "6px",
    },
});

export default function Announcements(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    // const [password, setPassword] = React.useState("");
    const rows = useSelector((state) => state.app.announcements);
    const page = useSelector((state) => state.app.page);
    const tool_drawer_width = useSelector((state) => state.app?.designer?.[APP.TOOL_DRAWER_WIDTH]);
    const SELECT_POINT = useSelector((state) => state.app.designer.designer2D[APP.SELECT_POINT]);
    const OrderStatus = useSelector((state) => state.job?.OrderStatus);
    const Locked = useSelector((state) => state.job?.App?.Locked);

    const linkRef = React.useRef();
    const [dialogData, setDialogData] = React.useState(false);
    const dismissedCookie = getCookie("dismissed");
    const [dismissedAnnouncements, setDismissedAnnouncements] = React.useState(
        dismissedCookie ? JSON.parse(dismissedCookie) : []
    );
    const {warningMessages}=props
    const customListIsOpen = useSelector((state) => state.app?.designer?.[APP.CUSTOM_COMPONENT_LIST_IS_OPEN]) ?? false ;
    const hasCustomBOM =
    (useSelector((state) => state.job?.QuoteParameters?.BOM?.OrderList?.items?.length) ?? 0) > 0 || customListIsOpen;
  
    useInterval(() => {
        dispatch(APP.updateAnnouncements());
    }, 5 * 60000);

    if (!rows || rows.length === 0 || SELECT_POINT) return <div className={classes.root}>&nbsp;</div>;

    const dismissAnnouncement = (id_plus_valid_to_ts) => {
        let new_dismissedAnnouncements = [...dismissedAnnouncements];
        new_dismissedAnnouncements.push(id_plus_valid_to_ts);
        setDismissedAnnouncements(new_dismissedAnnouncements);
        setCookie("dismissed", JSON.stringify(new_dismissedAnnouncements));
    };

    const is_designer = page === APP.DESIGNER_PAGE;
    const has_order_panel = is_designer && OrderStatus != undefined && OrderStatus !== "";

    const announcements = [];

    const right_padding = (is_designer && tool_drawer_width && tool_drawer_width > 0 ? tool_drawer_width : 0) + 10;

    for (const announcement of rows) {
        if (dismissedAnnouncements.includes(announcement.id + announcement.valid_to_ts)) continue;

        let announcement_image_url = announcement.image;
        if (announcement_image_url && !announcement_image_url.includes("http"))
            announcement_image_url = API_BASE() + "document/APP_announcements/" + announcement_image_url;

        announcements.push(
            <div
                className={
                    (is_designer ? classes.announcement_designer : classes.announcement) +
                    " " +
                    (announcement.type === "warning" ? classes.warning : "")
                }
            >
                {is_designer && (
                    <IconButton
                        className={classes.closeButton_designer}
                        color="primary"
                        aria-label="add to shopping cart"
                        onClick={(e) => {
                            dismissAnnouncement(announcement.id + announcement.valid_to_ts);
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                )}

                {announcement.image && (
                    <div>
                        <img
                            className={is_designer ? classes.image_designer : classes.image}
                            src={announcement_image_url}
                        />
                    </div>
                )}
                {announcement?.type === "warning" && (
                    <div>
                        <ReportProblemOutlinedIcon
                            style={
                                !is_designer
                                    ? {
                                          color: "#ff9e00",
                                          width: "48px",
                                          height: "48px",
                                          padding: "6px 12px",
                                      }
                                    : {
                                          color: "#ff9e00",
                                          width: "20px",
                                          height: "24px",
                                          padding: "0px 2px",
                                          marginRight: "8px",
                                      }
                            }
                        />
                    </div>
                )}

                <div className={classes.content_container} style={is_designer ? { flexDirection: "row" } : {}}>
                    {announcement.header && (
                        <div className={classes.header}>
                            <h3
                                style={{
                                    color: "#333333",
                                    margin: "0px",
                                    flex: 1,
                                    fontWeight: "bold",
                                    fontSize: is_designer ? "11px" : "18px",
                                }}
                            >
                                {announcement.header}
                            </h3>
                        </div>
                    )}
                    {announcement.content && (
                        <div
                            className={classes.content}
                            style={{
                                paddingRight:
                                    (announcement.action_link || announcement.action_content ? "0" : right_padding) +
                                    "px",
                            }}
                        >
                            <Typography
                                component="p"
                                variant="caption"
                                style={{
                                    color: "grey",
                                    textAlign: "left",
                                    fontSize: is_designer ? "0.65rem" : "0.85rem",
                                }}
                            >
                                {announcement.content}
                            </Typography>
                        </div>
                    )}
                    {(announcement.action_link || announcement.action_content) && (
                        <div className={classes.link} style={{ paddingRight: right_padding + "px" }}>
                            {announcement.action_content && (
                                <Link
                                    style={{
                                        color: Palette.FieldersBlue,
                                        cursor: "pointer",
                                        fontSize: is_designer ? "0.65rem" : "9pt",
                                    }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setDialogData({
                                            // error: true,
                                            title: announcement.header,
                                            message: [<>{announcement.action_content}</>],
                                            secondaryActionText:
                                                announcement.action_text && announcement.action_link
                                                    ? announcement.action_text
                                                    : false,
                                            secondaryAction: () => {
                                                linkRef.current.click();
                                            },
                                        });
                                    }}
                                >
                                    more info...
                                </Link>
                            )}
                            <a
                                ref={linkRef}
                                href={announcement.action_link}
                                style={{
                                    color: Palette.FieldersBlue,
                                    display: announcement.action_content ? "none" : "block",
                                }}
                                target="_blank"
                            >
                                {announcement.action_text ? announcement.action_text : announcement.action_link}
                            </a>
                        </div>
                    )}
                </div>

                {!is_designer && (
                    <IconButton
                        className={classes.closeButton}
                        color="primary"
                        aria-label="add to shopping cart"
                        onClick={(e) => {
                            dismissAnnouncement(announcement.id + announcement.valid_to_ts);
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                )}
            </div>
        );
    }

    if (!announcements || announcements.length === 0) return <div className={classes.root}>&nbsp;</div>;

    let style = {};
    const shouldHaveExtraTopPadding = has_order_panel || Locked || warningMessages?.length > 0 || hasCustomBOM
    if (is_designer)
        style = {
            zIndex: "50",
            position: "relative",
            paddingTop: shouldHaveExtraTopPadding ? "132px" : "85px",
        };

    return (
        <div className={classes.root} style={style}>
            {announcements}

            <BSL_Dialog
                title={dialogData.title}
                open={dialogData}
                onClose={() => setDialogData(false)}
                button1Text={dialogData?.primaryActionText ? dialogData?.primaryActionText : "OK"}
                button1Click={() => {
                    setDialogData(false);
                    if (dialogData?.primaryAction) dispatch(dialogData.primaryAction);
                }}
                button2Text={dialogData?.secondaryActionText}
                button2Click={() => {
                    setDialogData(false);
                    if (dialogData?.secondaryAction) dispatch(dialogData.secondaryAction);
                }}
            >
                {dialogData.message}
            </BSL_Dialog>
        </div>
    );
}
